import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

// app
import { enqueueNotification } from 'stores';
import { quoteBindAxios } from 'lib/quoteBind';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const usePutQuoteRates = () => {
  const dispatch = useDispatch();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.queries.usePutQuoteRates',
    };

    dispatch(enqueueNotification('notification.generic.request', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (res) => {
    dispatch(enqueueNotification('notification.putQuoteRates.success', 'success'));
  };

  return useMutation(
    async ({ commissionRates, quoteID }) => {
      if (isEmpty(commissionRates) || !quoteID) {
        throw new Error('Invalid data');
      }

      const path = `quotes/${quoteID}/rates`;

      const result = await quoteBindAxios.put(path, commissionRates);
      return result?.data;
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
